import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { useDropdownContext } from '../context.mjs';

const DropdownMenuTrigger = forwardRef(({ children, asChild = true, ...props }, forwardedRef) => {
  const { onTriggerChange } = useDropdownContext("Dropdown.Trigger");
  const composedRef = useComposedRefs(forwardedRef, onTriggerChange);
  return /* @__PURE__ */ jsx(
    DropdownMenuPrimitive.Trigger,
    {
      ref: composedRef,
      asChild,
      ...props,
      children
    }
  );
});

export { DropdownMenuTrigger };
//# sourceMappingURL=Trigger.mjs.map
